import { render, staticRenderFns } from "./datasource-form-tab1.vue?vue&type=template&id=362f1414&scoped=true&"
import script from "./datasource-form-tab1.vue?vue&type=script&lang=ts&"
export * from "./datasource-form-tab1.vue?vue&type=script&lang=ts&"
import style0 from "./datasource-form-tab1.vue?vue&type=style&index=0&id=362f1414&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362f1414",
  null
  
)

export default component.exports